import { Alert, AlertDescription, AlertIcon, Box, Button } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { urls } from "../../../urls";
import { OriginProcurementCancelledNotice } from "../OriginProcurementCancelledNotice";

export const DraftContractNotice = ({
  contractId,
  isCallOff,
  originProcurementCancelled,
  canDiscardDraft,
}: {
  contractId: string;
  isCallOff: boolean;
  originProcurementCancelled: boolean;
  canDiscardDraft: boolean;
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  if (originProcurementCancelled) {
    return <OriginProcurementCancelledNotice isCallOff={isCallOff} canDiscardDraft={canDiscardDraft} />;
  }
  return (
    <Alert status="info" rounded="md" mt="4" fontSize="sm" alignItems="flex-start">
      <AlertIcon />
      <Box>
        <AlertDescription>
          {isCallOff
            ? t("The call-off is a draft. Complete it to put it in force.")
            : t("The contract is a draft. Complete it to put it in force.")}
        </AlertDescription>
        <Button
          display="block"
          mt="2"
          size="sm"
          colorScheme="teal"
          onClick={() => navigate(urls.contracts.edit.go(contractId).details)}
        >
          {isCallOff ? t("Complete the call-off") : t("Complete the contract")}
        </Button>
      </Box>
    </Alert>
  );
};
